export const getReasonCodesSuccess = (reasonCodes) => {
    return {
        type: "GET_REASON_CODES_SUCCESS",
        payload: reasonCodes
    }
};
